module.exports = __webpack_public_path__ + "img/Jd.d5dfce13.png";